import { IBookmark, IResource, IResourceParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const resourcesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_resources: builder.query<ITableRes<IResource>, IResourceParams>({
      query: (params) => ({
        url: '/resources/',
        params,
      }),
      providesTags: ['resources'],
    }),
    GET_bookmarks: builder.query<ITableRes<IBookmark>, any>({
      query: (params) => ({
        url: '/bookmarks/',
        params,
      }),
      providesTags: ['bookmarks'],
    }),
    POST_addBookmark: builder.mutation<void, any>({
      query: (body) => ({
        url: `/bookmarks/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['bookmarks'],
    }),
    DELETE_deleteBookmark: builder.mutation<void, any>({
      query: (id) => ({
        url: `/bookmarks/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['bookmarks'],
    }),
  }),
})

export const {
  useGET_resourcesQuery,
  useGET_bookmarksQuery,
  usePOST_addBookmarkMutation,
  useDELETE_deleteBookmarkMutation,
} = resourcesAPI
